<template>
  <section class="over-page painel">
    <page-header title="Relatório Pedagógico" ref="header">
      <template v-slot:side>
        <!-- <select-control 
          :options="periodosLetivos" 
          placeholder="Selecione" 
          v-model="periodoLetivo" 
          @change="runFilter('periodoLetivo')"
        /> -->
        <a href="#" @click.prevent="goBack()" class="btn btn-secondary">
          Voltar
        </a>
      </template>
    </page-header>
    <form-spinner v-if="!ready" />
    <!-- <iframe
      :src="dashboard"
      frameborder="0"
      width="100%"
      :height="frameHeight"
      allowtransparency
      v-if="dashboard"
      @load="loaded()"
    ></iframe> -->
    <div
      class="pbi"
      id="powerBIcontainer"
    ></div>
  </section>
  
</template>

<script>
// var sign = require('jwt-encode')
import FormSpinner from '@/components/utilities/FormSpinner.vue'
import PbiService from '@/services/pbi.service.js'
import * as pbi from 'powerbi-client'

export default {
  components: {
    FormSpinner
  },
  props: {
    aluno: {
      type: Object
    },
    painel: {
      type: String
    },
    periodosLetivos: {
      type: Array
    },
    pl: {
      type: String
    }
  },
  data() {
    return {
      hash: 413,
      METABASE_SITE_URL: "https://dados.rededecisao.com",
      METABASE_SECRET_KEY: "ade7ff725d87baf8d7e2fbaf82ea7dba3605f8da0132f720d60f62915dc1ba39",
      pbiURI: 'https://app.fabric.microsoft.com/view?r=',
      payload: {
        resource: null,
        params: null,
        exp: Math.round(Date.now() / 1000) + (10 * 60) // 10 minute expiration
      },
      loading: false,
      pbi: null,
      pbiConfig: {
        id: null,
        token: null,
        dataset: null
      },
      pbiScope: {
        type: "report",
        tokenType: null,
        id: null,
        accessToken: null,
        embedUrl: null,
        permissions: null,
        settings: {
          filterPaneEnabled: false,
          navContentPaneEnabled: false
        }
      },
      currentUser: localStorage.getItem('profile') ? JSON.parse(atob(localStorage.getItem('profile'))) : null,
      dash: null,
      dashboard: null,
      dashboards: {
        pedagogico: {
          label: "Relatório Pedagógico",
          id: 696,
          params: {
            "periodo_letivo": "2025",
            "status_matricula": "MAT",
            "email_aluno": null
          },
        },
        frequencias: {
          label: "Frequências",
          id: 696,
          params: {
            "periodo_letivo": "2024",
            "status_matricula": "MAT",
            "email_aluno": null
          },
        },
        orientacoesestudo: {
          label: "Orientações de Estudo",
          id: 697,
          params: {
            "periodo_letivo": "2024",
            "email_aluno": null
          },
        },
        notificacoesescolares: {
          label: "Notificações Escolares",
          id: 698,
          params: {
            "periodo_letivo": "2024",
            "email_aluno": null
          },
        },
        avaliacoes: {
          label: "Avaliações",
          id: 699,
          params: {
            "periodo_letivo": "2024",
            "email_aluno": null
          },
        }
      },
      ready: false,
      frameHeight: 800,
      periodoLetivo: null
    }
  },
  mounted () {
    this.getPowerBi()
    // this.run()
    console.log("aluno", this.aluno)

    this.periodoLetivo = this.pl
  },
  methods: {
    setFrameHeight () {
      const hh = this.$refs.header
      console.log("hh:", hh)
    },
    getPowerBi () {
      PbiService.getPainel(this.hash).then(
        response => {
          console.log('getPainel:', response)

          this.pbiConfig.id = response.data.report
          this.pbiConfig.dataset = response.data.dataset
          this.pbiConfig.token = response.data.token
          
          setTimeout(() => {
            this.run()
          },200)
        },
        error => {
          console.error(error)
        }
      )
    },
    handleSrc () {
      if ( this.id == 'pbi' && this.hash ) {
        
        let powerbi = new pbi.service.Service(
            pbi.factories.hpmFactory,
            pbi.factories.wpmpFactory,
            pbi.factories.routerFactory
        )
        
        console.log('powerbi:', powerbi)
        console.log('pbiConfig:', this.pbiConfig)
        const self = this
        
        setTimeout(() => {
          var reportContainer = document.getElementById("powerBIcontainer")
          var painel = powerbi.embed(reportContainer, this.pbiConfig)

          painel.on("loaded", function() {
              console.log("loaded...")
              self.finishLoading()
          })
        },500)
      }
    },
    // run () {
    //   this.dash = this.dashboards[this.painel]

    //   if ( this.dash ) {
    //     var params = this.dash.params
    //     params.email_aluno = this.aluno.Aluno.emailAcademico
    //     params.periodo_letivo = this.periodoLetivo ?? this.pl

    //     const payload = {
    //       resource: { dashboard: this.dash.id },
    //       params: params,
    //       exp: Math.round(Date.now() / 1000) + 10 * 60,
    //     }

    //     console.log("payload:", payload)

    //     const token = sign(payload, this.METABASE_SECRET_KEY)
    //     this.dashboard = this.METABASE_SITE_URL + "/embed/dashboard/" + token + "#bordered=false&titled=false"

    //     this.$nextTick(() => {
    //       this.setFrameHeight()
    //     })
    //   }
    // },
    run () {
      // const { report, token, group } = data
      var permissions = pbi.models.Permissions.All
      
      console.log('aluno:', this.aluno)
      // const unidades = this.currentUser.unidades.flatMap( unidade => `'${unidade.label}'` ).toString()
      // console.log('unidades:', unidades)
      const emailAluno = this.aluno.Aluno.emailAcademico
      this.pbiScope.tokenType = pbi.models.TokenType.Embed
      this.pbiScope.id = this.pbiConfig.id
      this.pbiScope.accessToken = this.pbiConfig.token
      this.pbiScope.embedUrl =  `https://app.powerbi.com/reportEmbed?reportId=${ this.pbiConfig.id }&groupId=${ this.pbiConfig.dataset }&filter=consulta_email/email_aluno eq '${ emailAluno }'`
      this.pbiScope.permissions = permissions

      console.log("pbiConfig:", this.pbiScope)

      let powerbi = new pbi.service.Service(
          pbi.factories.hpmFactory,
          pbi.factories.wpmpFactory,
          pbi.factories.routerFactory
      )
      
      const self = this
      var reportContainer = document.getElementById("powerBIcontainer")

      setTimeout(() => {
          powerbi.reset(reportContainer)
          var painel = powerbi.embed(reportContainer, this.pbiScope)

          painel.on("loaded", function() {
              console.log("loaded...")
              self.finishLoading()
          })
        },300)

      // this.pbiConfig.accessToken = token
    },
    finishLoading () {      
      setTimeout (() => {
        window.spinner.emit("close")
        this.ready = true
      },1000)
    },
    runFilter () {
      this.dashboard = null
      this.ready = false
      
      setTimeout(() => {
        this.run()
      }, 500)
      
    },
    goBack () {
      this.$emit('onGoBack')
    },
    loaded () {
      this.ready = true
    }
  }
}

</script>

<style lang="scss" scoped>
  .painel {
    display: flex;
    flex-direction: column;
    
    iframe {
      flex: 1
    }
  }
</style>